<script>
import { get, debounce } from "lodash";
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";

const getSuggestions = (cmp) => {
  if (cmp.searchField.length > 3) {
    Fandom.ajax({
      method: "GET",
      url: `/api/v5/marketplace/spindox/autocomplete?search_text=${encodeURIComponent(cmp.searchField)}`,
      success: (data) => {
        cmp.suggestions = data;
      }
    });
  } else {
    Vue.set(cmp, "suggestions", []);
  }
}

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  data() {
    return {
      searchField: "",
      suggestions: [],
      resultUser: null,
      notices: [],
      transactionsMigration: {
        emailFrom: null,
        emailTo: null
      }
    }
  },
  computed: {
    user() {
      return get(globalState, ["pageModel", "user"], {});
    },
    name() {
      return [this.user.first_name, this.user.last_name].filter(Fandom.exists).join(" ");
    },
    canSearch() {
      return this.suggestions.map(s => s.email).includes(this.searchField);
    },
    isTrovaBandoRequested() {
      return (this.resultUser?.active_editions || []).find(ed => this.getEdition(ed).trovabando);
    }
  },
  watch: {
    searchField() {
      const cmp = this;
      debounce(() => getSuggestions(cmp), 500)();
    }
  },
  methods: {
    printJSON: JSON.stringify,
    getUser() {
      const user_email = this.suggestions.find(s => s.email === this.searchField)?.email;
      Fandom.ajax({
        method: "GET",
        url: `/api/v5/marketplace/spindox/user?user_email=${encodeURIComponent(user_email)}`,
        success: (data) => {
          Vue.set(this, 'resultUser', data);
          if (!data.id) {
            this.notices.push({type: "warning", message: "<strong>ATTENZIONE:</strong> questo utente non è attualmente registrato alla piattaforma \"Vodafone Business Lab\""});
          }
        }
      });
    },
    resendPurchaseWelcomeMail(edition) {
      Vue.set(this, 'notices', []);
      Fandom.ajax({
        method: "POST",
        data: {
          user_email: this.resultUser.email,
          edition_name: edition
        },
        url: "/api/v5/marketplace/spindox/purchase_email",
        success: (_) => {
          this.notices.push({type: "success", message: this.ft("globals.operation_success")});
        },
        error: (_) => {
          this.notices.push({type: "danger", message: this.ft("globals.operation_error")});
        }
      });
    },
    migrateUserTransactions() {
      Vue.set(this, 'notices', []);
      Fandom.ajax({
        method: "POST",
        data: {
          mail_from: this.transactionsMigration.emailFrom,
          mail_to: this.transactionsMigration.emailTo
        },
        url: "/api/v5/marketplace/spindox/migrate_customer_transactions",
        success: (_) => {
          this.notices.push({type: "success", message: this.ft("globals.operation_success")});
        },
        error: (err) => {
          this.notices.push({type: "danger", message: `${this.ft("globals.operation_error")}<ul><li>${get(err, ["responseJSON","errors",0], "")}</li></ul>`});
        }
      });
    },
    removeNotice(index) {
      this.notices.splice(index,1);
    },
    getLocaleTime(timestamp) {
      const date = new Date(timestamp);
      return `${date.toLocaleDateString("it-IT", {day: 'numeric', month: 'long', year: 'numeric'})} ${date.toLocaleTimeString("it-IT", { hour: '2-digit', minute: '2-digit' })}`;
    },
    getAction(action) {
      const actionCodeToString = {
        "SUBSCRIPTION_ORDER": "Avvenuta sottoscrizione",
        "SUBSCRIPTION_CHANGE": "Avvenuta modifica sottoscrizione",
        "SUBSCRIPTION_CANCEL": "Avvenuto annullamento sottoscrizione"
      }
      return actionCodeToString[action];
    },
    getEdition(name) {
      return get(this.content, ["edition_name_to_content", name], {});
    }
  },
};
</script>

<template>
  <div class="poisition-relative mh-100vh-header" v-easyadmin="easyadminId" :class="contentType" v-if="isContentVisibleToUser()" >
    <div class="w-100 bg-vodafone">
      <div class="container py-5">
        <div class="row align-items-center user-greetings">
          <div class="col-12 text-white">
            <h2 class="font-weight-light">Pagina utente spindox</h2>
            <h4>Benvenuto <strong>{{name}}</strong></h4>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 px-4" v-if="notices.length > 0">
      <div v-for="(notice, nindex) in notices" :key="`${nindex}-notice`" :class="`alert-${notice.type}`" class="alert alert-dismissible show my-4" role="alert">
        <span v-html="notice.message"></span>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeNotice(nindex)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="w-100 bg-white py-4">
      <div class="container">
        <div class="form-group col-lg-8">
          <h4>Accedi con un utente</h4>
          <div class="input-group">
            <input
              list="suggestions"
              v-model="searchField"
              placeholder="mario.rossi@website.domain"
              class ="form-control" type="email"
            >
            <div class="input-group-append">
              <button class="btn btn-primary" @click="getUser()" :disabled="!canSearch" type="button">Trova</button>
            </div>
          </div>
          <datalist v-if="suggestions.length > 0" id="suggestions">
            <option
              v-for="(suggestion, index) in suggestions"
              :key="`suggestion-${index}`"
              :value="suggestion.email"
              :class="suggestion.id ? 'text-success' : 'text-danger'"
            >
              <span v-if="!suggestion.id" class="small">Utente NON registrato</span>
            </option>
          </datalist>
        </div>
      </div>
    </div>
    <div class="w-100 bg-gray-200 py-4" v-if="resultUser">
      <div class="container">
        <div class="row">
          <div class="col-12"><h4>Utente selezionato: {{resultUser.email}}</h4></div>
          <dt class="col-sm-3">Id</dt>
          <dd class="col-sm-9">{{resultUser.id || 'dato mancante'}}</dd>
          <dt class="col-sm-3">Email</dt>
          <dd class="col-sm-9">{{resultUser.email}}</dd>
          <dt class="col-sm-3">Nome</dt>
          <dd class="col-sm-9"><span v-if="resultUser.first_name">{{resultUser.first_name}}</span><span class="text-muted" v-else>dato mancante</span></dd>
          <dt class="col-sm-3">Cognome</dt>
          <dd class="col-sm-9"><span v-if="resultUser.last_name">{{resultUser.last_name}}</span><span class="text-muted" v-else>dato mancante</span></dd>

          <dt class="col-sm-3 d-flex align-items-center">Edizioni attive</dt>
          <dd class="col-sm-9">
            <div class="d-flex flex-wrap mx-n2" v-if="resultUser.active_editions && resultUser.active_editions.length > 0">
              <div class="badge badge-primary m-2 p-2" v-for="edition in resultUser.active_editions" :key="edition">{{getEdition(edition).title}}</div>
            </div>
            <span class="text-muted" v-else>nessuna edizione attiva</span>
          </dd>

          <dt class="col-sm-3 d-flex align-items-center" v-if="resultUser.active_editions && resultUser.active_editions.length > 0">Reinvia email di benvenuto</dt>
          <dd class="col-sm-9" v-if="resultUser.active_editions && resultUser.active_editions.length > 0">
            <div class="d-flex flex-wrap mx-n2">
              <button
                class="btn btn-outline-primary btn-sm m-2"
                v-for="edition in resultUser.active_editions"
                :key="edition"
                @click="resendPurchaseWelcomeMail(edition)"
              >Email per {{getEdition(edition).title}}</button>
            </div>
          </dd>

          <dt class="col-sm-3 d-flex align-items-center">Trovabando</dt>
          <dd class="col-sm-9">
            <a
              :href="`/trovabando/redirect?user_id=${resultUser.id}`"
              target="blank"
              class="btn btn-outline-primary btn-sm"
              :disabled="!isTrovaBandoRequested || !(resultUser.id)"
              :class="{'disabled': !isTrovaBandoRequested || !(resultUser.id)}"
            >Accedi</a>
          </dd>
          
          <dt class="col-sm-3">Storico transazioni</dt>
          <dd class="col-sm-9">
            <ul class="list-unstyled small" v-if="resultUser.marketplace_history">
              <li v-for="(transaction, index) in resultUser.marketplace_history" :key="`transaction-${index}`">
                <hr>
                <div class="row">
                  <dt class="col-sm-3">Timestamp</dt>
                  <dd class="col-sm-9">{{getLocaleTime(transaction.timestamp)}}</dd>
                  <dt class="col-sm-3">Azione</dt>
                  <dd class="col-sm-9">{{transaction.action}}</dd>
                  <dt class="col-sm-3" v-if="transaction.edition">Edizione</dt>
                  <dd class="col-sm-9" v-if="transaction.edition">{{getEdition(transaction.edition).title}}</dd>
                  <dt class="col-sm-3">accountIdentifier</dt>
                  <dd class="col-sm-9">{{transaction.account_identifier}}</dd>
                </div>
              </li>
            </ul>
            <span class="text-muted" v-else>nessuna transazione</span>
          </dd>
        </div>
      </div>
    </div>
    <div class="w-100 bg-white py-4 border-top">
      <div class="container">
        <div class="form-group col-lg-8">
          <h4>Migra transazioni utente</h4>
          <div class="input-group w-100">
            <div class="input-group-prepend">
              <div class="input-group-text">Email utente sorgente</div>
            </div>
            <input
              v-model="transactionsMigration.emailFrom"
              placeholder="info@website.domain"
              class ="form-control" type="email"
            >
          </div>
          <div class="input-group mt-4 w-100">
            <div class="input-group-prepend">
              <div class="input-group-text">Email utente destinatario</div>
            </div>
            <input
              v-model="transactionsMigration.emailTo"
              class ="form-control" type="email"
              placeholder="francesco.rossi@website.domain"
            >
          </div>
          <button class="btn btn-primary mt-4 mr-0" @click="migrateUserTransactions">Applica</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
</style>
